import { useMutation, useQueryClient } from "@tanstack/react-query";

import { rejectProposal } from "./api";
import type { Proposal } from "./api";

// Отклонение предложения (pending → rejected). На успех
// инвалидируем список — кнопки исчезнут, статус сменится на rejected.
// Ошибку (404 / 409 не pending) пробрасываем наверх для тоста.
// Инвалидация по смысловому префиксу матчит запись любого org-скоупа
// (см. `src/query/scope.ts`).
export function useRejectProposal(): ReturnType<
  typeof useMutation<Proposal, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<Proposal, Error, string>({
    mutationFn: (id) => rejectProposal(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["self-improvement", "proposals"],
      });
    },
  });
}
